import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css'; // We'll create this next with global styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import MFALoginGate from './components/MFA/MFALoginGate';
import { BudgetProvider } from './context/BudgetContext';
import { CrewLinkNotificationProvider } from './context/CrewLinkNotificationContext';
import { ExchangeNotificationProvider } from './context/ExchangeNotificationContext';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <AuthProvider>
      <MFALoginGate>
        <BudgetProvider>
          <CrewLinkNotificationProvider>
            <ExchangeNotificationProvider>
              <App />
            </ExchangeNotificationProvider>
          </CrewLinkNotificationProvider>
        </BudgetProvider>
      </MFALoginGate>
    </AuthProvider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 